// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* 스마트 안전지도 신규 대시보드 */

.safemap-redesign {
    flex: 1 1;
    width: 0;
    padding: 14px 24px;
    background: #f3f6fa;
    color: #26354a;
    font-family: 'Pretendard', 'Malgun Gothic', Arial, sans-serif;
    min-width: 0;
    box-sizing: border-box;
  }

  .safemap-redesign *,
  .safemap-redesign *::before,
  .safemap-redesign *::after {
    box-sizing: border-box;
  }

  /* 대시보드 그리드 */

  .safemap-redesign .dashboard-grid {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 12px;
    margin-bottom: 12px;
  }

  /* 패널 */

  .safemap-redesign .panel {
    background: white;
    border-radius: 10px;
    padding: 15px 18px;
    box-shadow: 0 2px 9px rgba(30, 55, 90, 0.06);
    min-width: 0;
  }

  .safemap-redesign .panel h3 {
    font-size: 15px;
    margin: 0 0 12px;
    font-weight: 600;
  }

  /* 통계 */

  .safemap-redesign .stat-grid {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 10px;
  }

  .safemap-redesign .stat-grid.three {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .safemap-redesign .stat-box {
    background: #f4f7fb;
    border-radius: 8px;
    padding: 10px 8px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 4px;
  }

  .safemap-redesign .stat-box span {
    font-size: 13px;
    color: #67758b;
  }

  .safemap-redesign .stat-box strong {
    font-size: 25px;
    font-weight: 700;
  }

  .safemap-redesign .stat-box small {
    color: #78869a;
  }

  .safemap-redesign .danger {
    color: #e35d64;
  }

  /* 시연용 안내 */

  .safemap-redesign .mock-notice {
    font-size: 11px;
    color: #96a0ae;
    text-align: left;
    line-height: 1.6;
    white-space: normal;
    overflow-wrap: anywhere;
    margin: 10px 0 4px;
  }

  /* 반응형 */

  @media (max-width: 1000px) {
    .safemap-redesign .dashboard-grid {
      grid-template-columns: 1fr;
    }
  }

  @media (max-width: 650px) {
    .safemap-redesign {
      padding: 14px 12px;
    }

    .safemap-redesign .stat-grid.three {
      grid-template-columns: 1fr;
    }
  }

  /* 위험등급별 사용자 현황 */

.safemap-redesign .risk-summary {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 3px 2px 9px;
    font-size: 14px;
  }

  .safemap-redesign .risk-summary strong {
    font-size: 21px;
    color: #26354a;
  }

  .safemap-redesign .risk-progress {
    display: flex;
    height: 22px;
    overflow: hidden;
    border-radius: 5px;
    margin-bottom: 12px;
    background: #edf0f4;
  }

  .safemap-redesign .risk-segment {
    height: 100%;
  }

  .safemap-redesign .risk-high {
    background: #f36b70;
  }

  .safemap-redesign .risk-medium {
    background: #ffcb26;
  }

  .safemap-redesign .risk-low {
    background: #5b9bf1;
  }

  .safemap-redesign .risk-cards {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 10px;
  }

  .safemap-redesign .risk-card {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    padding: 9px 6px;
    border-radius: 7px;
    background: #f4f7fb;
    font-size: 13px;
    white-space: nowrap;
  }

  .safemap-redesign .risk-card strong {
    font-size: 16px;
  }

  .safemap-redesign .risk-dot {
    width: 10px;
    height: 10px;
    border-radius: 50%;
    flex-shrink: 0;
  }

  @media (max-width: 1200px) {
    .safemap-redesign .risk-cards {
      grid-template-columns: 1fr;
    }

    .safemap-redesign .risk-card {
      justify-content: space-between;
    }
  }

  /* 장비 이상 사용자 현황 */

.safemap-redesign .abnormal-table-scroll {
    max-height: 175px;
    overflow-x: auto;
    overflow-y: auto;
  }

  .safemap-redesign .abnormal-table {
    width: 100%;
    border-collapse: collapse;
    font-size: 13px;
  }

  .safemap-redesign .abnormal-table th,
  .safemap-redesign .abnormal-table td {
    padding: 6px 8px;
    border-bottom: 1px solid #edf0f4;
    text-align: center;
    vertical-align: middle;
    white-space: nowrap;
  }

  .safemap-redesign .abnormal-table th {
    position: sticky;
    top: 0;
    z-index: 1;
    background: #f4f7fb;
    color: #67758b;
    font-weight: 600;
  }

  .safemap-redesign .abnormal-table td:nth-child(2) {
    text-align: left;
  }

  /* 장비 상태 표시 */

  .safemap-redesign .status-normal,
  .safemap-redesign .status-danger,
  .safemap-redesign .status-uninstalled {
    display: inline-flex;
    align-items: center;
    justify-content: center;

    width: 62px;
    height: 24px;
    padding: 0 4px;

    border-radius: 4px;
    font-size: 12px;
    font-weight: 600;
    white-space: nowrap;
  }

  .safemap-redesign .status-normal {
    color: white;
    background: #21bf73;
  }

  .safemap-redesign .status-danger {
    color: white;
    background: #ef5350;
  }

  .safemap-redesign .status-uninstalled {
    color: #666;
    background: #e5e7eb;
  }

  /* 스크롤바 */

  .safemap-redesign .abnormal-table-scroll::-webkit-scrollbar {
    width: 7px;
    height: 7px;
  }

  .safemap-redesign .abnormal-table-scroll::-webkit-scrollbar-thumb {
    background: #cbd5e1;
    border-radius: 10px;
  }

  .safemap-redesign .abnormal-table-scroll::-webkit-scrollbar-track {
    background: #f4f7fb;
  }

  /* 읍면별 장비 현황 그래프 */

.safemap-redesign .chart-panel {
    margin-top: 12px;
  }

  .safemap-redesign .panel-heading {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 16px;
  }

  .safemap-redesign .panel-heading h3 {
    margin: 0;
  }

  .safemap-redesign .panel-heading select {
    padding: 9px 34px 9px 12px;
    border: 1px solid #dbe2eb;
    border-radius: 6px;
    background: white;
    cursor: pointer;
  }

  .safemap-redesign .chart-summary {
    display: flex;
    gap: 25px;
    margin: 10px 0;
    font-size: 14px;
  }

  .safemap-redesign .chart-summary strong {
    margin-left: 7px;
  }

  .safemap-redesign .chart-container {
    width: 100%;
    height: clamp(160px, 20vh, 215px);
    min-width: 0;
  }

  /* 대시보드 우측 상단 읍면별 사용자 조회 */

.safemap-redesign .dashboard-top-controls {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    gap: 12px;
    margin-bottom: 10px;
  }

  .safemap-redesign .dashboard-top-controls label {
    font-size: 13px;
    font-weight: 600;
    color: #52647a;
  }

  .safemap-redesign .dashboard-top-controls select {
    min-width: 170px;
    padding: 10px 12px;
    border: 1px solid #dbe2eb;
    border-radius: 7px;
    background: white;
    color: #26354a;
    cursor: pointer;
  }

  @media (max-width: 650px) {
    .safemap-redesign .dashboard-top-controls {
      justify-content: flex-start;
      flex-wrap: wrap;
    }
  }

  /* 기기 설치 현황 - 숫자 및 상태 문구 줄바꿈 방지 */
.safemap-redesign .stat-box strong {
    white-space: nowrap;
  }

/* 대시보드 전체 높이 */
.safemap-redesign {
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
  }

  /* 상단 2x2 패널은 기존 높이 유지 */
  .safemap-redesign .dashboard-grid {
    flex: 0 0 auto;
  }

  /* 하단 그래프만 남는 공간 활용 */
  .safemap-redesign .chart-panel {
    flex: 1 0 300px;
    display: flex;
    flex-direction: column;
  }

  /* 그래프 크기는 적당한 범위로 제한 */
  .safemap-redesign .chart-container {
    flex: 1 1;
    min-height: 200px;
    max-height: 340px;
  }

  /* 위험등급별 사용자 현황 - 세로 중앙 배치 */
.safemap-redesign .risk-panel {
display: flex;
flex-direction: column;
justify-content: center;
position: relative;
}

/* 제목은 패널 상단에 고정 */
.safemap-redesign .risk-panel > h3 {
position: absolute;
top: 16px;
left: 16px;
margin: 0;
}

/* 장비 이상 사용자 행 클릭 효과 */
.safemap-redesign .abnormal-table tbody tr {
    cursor: pointer;
    transition: background-color 0.15s ease;
}

.safemap-redesign .abnormal-table tbody tr:hover {
    background-color: #eaf3ff;
}

/* 신규 대시보드 - 발생현황 모달 */

.safemap-redesign .modalbg {
    position: fixed !important;
    inset: 0;
    z-index: 9998;
    background: rgba(0, 0, 0, 0.4);
  }

  .safemap-redesign .modal.occurmodal {
    display: block !important;
    position: fixed !important;

    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);

    width: min(1600px, 95vw);
    max-height: 90vh;
    overflow-y: auto;

    margin: 0;
    padding: 24px;
    background: #fff;
    border-radius: 10px;
    box-shadow: 0 10px 35px rgba(0, 0, 0, 0.2);

    z-index: 9999;
  }

  /* 신규 대시보드 - 상황종료 모달 */

.safemap-redesign .modal.processmodal {
    display: block !important;
    position: fixed !important;

    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);

    width: min(1200px, 92vw);
    max-height: 85vh;
    overflow-y: auto;

    margin: 0;
    padding: 24px;
    background: #fff;
    border-radius: 10px;
    box-shadow: 0 10px 35px rgba(0, 0, 0, 0.2);

    z-index: 9999;
  }

  /* 장비 이상 사용자 목록 - 좁은 화면 너비 대응 - 1336 */
.safemap-redesign .abnormal-table {
    table-layout: fixed;
  }

  .safemap-redesign .abnormal-table th,
  .safemap-redesign .abnormal-table td {
    padding: 6px 4px;
  }

  .safemap-redesign .abnormal-table th:nth-child(1),
  .safemap-redesign .abnormal-table td:nth-child(1) {
    width: 22%;
  }

  .safemap-redesign .abnormal-table th:nth-child(2),
  .safemap-redesign .abnormal-table td:nth-child(2) {
    width: 38%;
    white-space: normal;
    overflow-wrap: anywhere;
  }

  .safemap-redesign .abnormal-table th:nth-child(n+3),
  .safemap-redesign .abnormal-table td:nth-child(n+3) {
    width: 20%;
  }

  /* 장비 이상 사용자 현황 - 5열 너비 최적화 */
.safemap-redesign .abnormal-table {
    width: 100%;
    table-layout: fixed;
  }

  .safemap-redesign .abnormal-table th,
  .safemap-redesign .abnormal-table td {
    padding: 6px 4px;
  }

  /* 어르신 사용자 */
  .safemap-redesign .abnormal-table th:nth-child(1),
  .safemap-redesign .abnormal-table td:nth-child(1) {
    width: 18%;
    overflow-wrap: anywhere;
    white-space: normal;
  }

  /* 설치위치 */
  .safemap-redesign .abnormal-table th:nth-child(2),
  .safemap-redesign .abnormal-table td:nth-child(2) {
    width: 28%;
    white-space: normal;
    overflow-wrap: anywhere;
  }

  /* 플러그, 스위치, 감지기 */
  .safemap-redesign .abnormal-table th:nth-child(n+3),
  .safemap-redesign .abnormal-table td:nth-child(n+3) {
    width: 18%;
  }

  /* 좁은 화면에서 위험등급 패널 제목 겹침 방지 - 768 */
@media (max-width: 1000px) {
    .safemap-redesign .risk-panel {
      justify-content: flex-start;
    }

    .safemap-redesign .risk-panel > h3 {
      position: static;
      margin-bottom: 16px;
    }
  }

  /* =========================================
   대시보드 글씨 크기 통일
   사용자 관리 / 장비 관리와 동일한 기준
========================================= */

/* 패널 제목 */
.safemap-redesign .panel h3 {
    font-size: 18px;
    line-height: 1.4;
  }
  
  /* 통계 항목명 */
  .safemap-redesign .stat-box span {
    font-size: 15px;
  }
  
  /* 주요 통계 숫자는 기존 강조 크기 유지 */
  .safemap-redesign .stat-box strong {
    font-size: 25px;
  }
  
  /* 위험등급별 사용자 현황 */
  .safemap-redesign .risk-summary {
    font-size: 15px;
  }
  
  .safemap-redesign .risk-card {
    font-size: 15px;
  }
  
  /* 장비 이상 사용자 목록 */
  .safemap-redesign .abnormal-table {
    font-size: 15px;
  }
  
  .safemap-redesign .abnormal-table th,
  .safemap-redesign .abnormal-table td {
    padding: 8px 4px;
    line-height: 1.4;
  }
  
  /* 장비 상태 표시 */
  .safemap-redesign .status-normal,
  .safemap-redesign .status-danger,
  .safemap-redesign .status-uninstalled {
    font-size: 13px;
    width: 68px;
    height: 27px;
  }
  
  /* 읍면별 사용자 선택 */
  .safemap-redesign .dashboard-top-controls label,
  .safemap-redesign .dashboard-top-controls select {
    font-size: 14px;
  }
  
  /* 그래프 상단 선택 및 요약 */
  .safemap-redesign .panel-heading select {
    font-size: 14px;
  }
  
  .safemap-redesign .chart-summary {
    font-size: 15px;
  }
  
  /* 안내 문구 */
  .safemap-redesign .mock-notice {
    font-size: 12px;
  }

  /* =========================================
   대시보드 세로 공간 재배분
========================================= */

/* 상단 통계 카드의 내부 여백 확대 */
.safemap-redesign .dashboard-grid > .panel:nth-child(-n+2) {
    padding-top: 24px;
    padding-bottom: 24px;
  }
  
  /* 응급상황 / 기기 설치 현황의 숫자 카드 */
  .safemap-redesign .dashboard-grid > .panel:nth-child(-n+2) .stat-box {
    padding-top: 18px;
    padding-bottom: 18px;
    gap: 8px;
  }
  
  /* 하단 그래프 패널이 과도하게 커지지 않도록 */
  .safemap-redesign .chart-panel {
    flex: 0 0 auto;
  }
  
  /* 그래프 높이 조정 */
  .safemap-redesign .chart-container {
    height: 250px;
    min-height: 250px;
    max-height: 250px;
    flex: none;
  }

  /* 대시보드 하단 그래프 - 남는 화면 높이 활용 */

.safemap-redesign .chart-container {
    height: clamp(250px, calc(100vh - 670px), 480px);
    min-height: 250px;
    max-height: none;
    flex: none;
  }
/* 발생현황 내부 사용자 상세정보 모달 */
.safemap-redesign .modal.user-detail-modal {
  display: block !important;
  position: fixed !important;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: min(650px, 90vw);
  max-height: 80vh;
  overflow-y: auto;
  margin: 0;
  padding: 24px;
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 10px 35px rgba(0, 0, 0, 0.25);
  z-index: 10001;
}

/* 발생현황 모달 테이블 가독성 개선 */
.safemap-redesign .modal.occurmodal {
    box-sizing: border-box;
}

.safemap-redesign .modal.occurmodal .table {
    width: 100%;
    overflow-x: auto;
}

.safemap-redesign .modal.occurmodal table {
    width: 100%;
    min-width: 1150px;
    table-layout: auto;
}

.safemap-redesign .modal.occurmodal th,
.safemap-redesign .modal.occurmodal td {
    white-space: nowrap;
    word-break: keep-all;
    vertical-align: middle;
    padding: 12px 10px;
}

.safemap-redesign .modal.occurmodal td button {
    white-space: nowrap;
    min-width: max-content;
}

/* 보호자 확인 시각 등 긴 정보는 한 줄 유지 */
.safemap-redesign .modal.occurmodal td div {
    white-space: nowrap;
}
`, "",{"version":3,"sources":["webpack://./src/components/dashboard/DashboardRedesign.css"],"names":[],"mappings":"AAAA,qBAAqB;;AAErB;IACI,SAAO;IACP,QAAQ;IACR,kBAAkB;IAClB,mBAAmB;IACnB,cAAc;IACd,6DAA6D;IAC7D,YAAY;IACZ,sBAAsB;EACxB;;EAEA;;;IAGE,sBAAsB;EACxB;;EAEA,aAAa;;EAEb;IACE,aAAa;IACb,gDAAgD;IAChD,SAAS;IACT,mBAAmB;EACrB;;EAEA,OAAO;;EAEP;IACE,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,4CAA4C;IAC5C,YAAY;EACd;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA,OAAO;;EAEP;IACE,aAAa;IACb,gDAAgD;IAChD,SAAS;EACX;;EAEA;IACE,gDAAgD;EAClD;;EAEA;IACE,mBAAmB;IACnB,kBAAkB;IAClB,iBAAiB;IACjB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,QAAQ;EACV;;EAEA;IACE,eAAe;IACf,cAAc;EAChB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA,WAAW;;EAEX;IACE,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;EACpB;;EAEA,QAAQ;;EAER;IACE;MACE,0BAA0B;IAC5B;EACF;;EAEA;IACE;MACE,kBAAkB;IACpB;;IAEA;MACE,0BAA0B;IAC5B;EACF;;EAEA,iBAAiB;;AAEnB;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,oBAAoB;IACpB,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,cAAc;EAChB;;EAEA;IACE,aAAa;IACb,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,gDAAgD;IAChD,SAAS;EACX;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;IACR,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,cAAc;EAChB;;EAEA;IACE;MACE,0BAA0B;IAC5B;;IAEA;MACE,8BAA8B;IAChC;EACF;;EAEA,iBAAiB;;AAEnB;IACI,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,yBAAyB;IACzB,eAAe;EACjB;;EAEA;;IAEE,gBAAgB;IAChB,gCAAgC;IAChC,kBAAkB;IAClB,sBAAsB;IACtB,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;IAChB,MAAM;IACN,UAAU;IACV,mBAAmB;IACnB,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA,aAAa;;EAEb;;;IAGE,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;;IAEvB,WAAW;IACX,YAAY;IACZ,cAAc;;IAEd,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,YAAY;IACZ,mBAAmB;EACrB;;EAEA;IACE,YAAY;IACZ,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,mBAAmB;EACrB;;EAEA,SAAS;;EAET;IACE,UAAU;IACV,WAAW;EACb;;EAEA;IACE,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA,kBAAkB;;AAEpB;IACI,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,SAAS;EACX;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,0BAA0B;IAC1B,yBAAyB;IACzB,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,SAAS;IACT,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,iCAAiC;IACjC,YAAY;EACd;;EAEA,0BAA0B;;AAE5B;IACI,aAAa;IACb,yBAAyB;IACzB,mBAAmB;IACnB,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,gBAAgB;IAChB,kBAAkB;IAClB,yBAAyB;IACzB,kBAAkB;IAClB,iBAAiB;IACjB,cAAc;IACd,eAAe;EACjB;;EAEA;IACE;MACE,2BAA2B;MAC3B,eAAe;IACjB;EACF;;EAEA,iCAAiC;AACnC;IACI,mBAAmB;EACrB;;AAEF,eAAe;AACf;IACI,iBAAiB;IACjB,aAAa;IACb,sBAAsB;IACtB,sBAAsB;EACxB;;EAEA,wBAAwB;EACxB;IACE,cAAc;EAChB;;EAEA,qBAAqB;EACrB;IACE,eAAe;IACf,aAAa;IACb,sBAAsB;EACxB;;EAEA,uBAAuB;EACvB;IACE,SAAO;IACP,iBAAiB;IACjB,iBAAiB;EACnB;;EAEA,4BAA4B;AAC9B;AACA,aAAa;AACb,sBAAsB;AACtB,uBAAuB;AACvB,kBAAkB;AAClB;;AAEA,kBAAkB;AAClB;AACA,kBAAkB;AAClB,SAAS;AACT,UAAU;AACV,SAAS;AACT;;AAEA,sBAAsB;AACtB;IACI,eAAe;IACf,uCAAuC;AAC3C;;AAEA;IACI,yBAAyB;AAC7B;;AAEA,sBAAsB;;AAEtB;IACI,0BAA0B;IAC1B,QAAQ;IACR,aAAa;IACb,8BAA8B;EAChC;;EAEA;IACE,yBAAyB;IACzB,0BAA0B;;IAE1B,QAAQ;IACR,SAAS;IACT,gCAAgC;;IAEhC,wBAAwB;IACxB,gBAAgB;IAChB,gBAAgB;;IAEhB,SAAS;IACT,aAAa;IACb,gBAAgB;IAChB,mBAAmB;IACnB,0CAA0C;;IAE1C,aAAa;EACf;;EAEA,sBAAsB;;AAExB;IACI,yBAAyB;IACzB,0BAA0B;;IAE1B,QAAQ;IACR,SAAS;IACT,gCAAgC;;IAEhC,wBAAwB;IACxB,gBAAgB;IAChB,gBAAgB;;IAEhB,SAAS;IACT,aAAa;IACb,gBAAgB;IAChB,mBAAmB;IACnB,0CAA0C;;IAE1C,aAAa;EACf;;EAEA,sCAAsC;AACxC;IACI,mBAAmB;EACrB;;EAEA;;IAEE,gBAAgB;EAClB;;EAEA;;IAEE,UAAU;EACZ;;EAEA;;IAEE,UAAU;IACV,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;;IAEE,UAAU;EACZ;;EAEA,6BAA6B;AAC/B;IACI,WAAW;IACX,mBAAmB;EACrB;;EAEA;;IAEE,gBAAgB;EAClB;;EAEA,YAAY;EACZ;;IAEE,UAAU;IACV,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA,SAAS;EACT;;IAEE,UAAU;IACV,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA,kBAAkB;EAClB;;IAEE,UAAU;EACZ;;EAEA,mCAAmC;AACrC;IACI;MACE,2BAA2B;IAC7B;;IAEA;MACE,gBAAgB;MAChB,mBAAmB;IACrB;EACF;;EAEA;;;2CAGyC;;AAE3C,UAAU;AACV;IACI,eAAe;IACf,gBAAgB;EAClB;;EAEA,WAAW;EACX;IACE,eAAe;EACjB;;EAEA,0BAA0B;EAC1B;IACE,eAAe;EACjB;;EAEA,iBAAiB;EACjB;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA,iBAAiB;EACjB;IACE,eAAe;EACjB;;EAEA;;IAEE,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA,aAAa;EACb;;;IAGE,eAAe;IACf,WAAW;IACX,YAAY;EACd;;EAEA,eAAe;EACf;;IAEE,eAAe;EACjB;;EAEA,mBAAmB;EACnB;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA,UAAU;EACV;IACE,eAAe;EACjB;;EAEA;;2CAEyC;;AAE3C,uBAAuB;AACvB;IACI,iBAAiB;IACjB,oBAAoB;EACtB;;EAEA,2BAA2B;EAC3B;IACE,iBAAiB;IACjB,oBAAoB;IACpB,QAAQ;EACV;;EAEA,4BAA4B;EAC5B;IACE,cAAc;EAChB;;EAEA,cAAc;EACd;IACE,aAAa;IACb,iBAAiB;IACjB,iBAAiB;IACjB,UAAU;EACZ;;EAEA,8BAA8B;;AAEhC;IACI,gDAAgD;IAChD,iBAAiB;IACjB,gBAAgB;IAChB,UAAU;EACZ;AACF,wBAAwB;AACxB;EACE,yBAAyB;EACzB,0BAA0B;EAC1B,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,uBAAuB;EACvB,gBAAgB;EAChB,gBAAgB;EAChB,SAAS;EACT,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,2CAA2C;EAC3C,cAAc;AAChB;;AAEA,uBAAuB;AACvB;IACI,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;;IAEI,mBAAmB;IACnB,oBAAoB;IACpB,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA,6BAA6B;AAC7B;IACI,mBAAmB;AACvB","sourcesContent":["/* 스마트 안전지도 신규 대시보드 */\r\n\r\n.safemap-redesign {\r\n    flex: 1;\r\n    width: 0;\r\n    padding: 14px 24px;\r\n    background: #f3f6fa;\r\n    color: #26354a;\r\n    font-family: 'Pretendard', 'Malgun Gothic', Arial, sans-serif;\r\n    min-width: 0;\r\n    box-sizing: border-box;\r\n  }\r\n\r\n  .safemap-redesign *,\r\n  .safemap-redesign *::before,\r\n  .safemap-redesign *::after {\r\n    box-sizing: border-box;\r\n  }\r\n\r\n  /* 대시보드 그리드 */\r\n\r\n  .safemap-redesign .dashboard-grid {\r\n    display: grid;\r\n    grid-template-columns: repeat(2, minmax(0, 1fr));\r\n    gap: 12px;\r\n    margin-bottom: 12px;\r\n  }\r\n\r\n  /* 패널 */\r\n\r\n  .safemap-redesign .panel {\r\n    background: white;\r\n    border-radius: 10px;\r\n    padding: 15px 18px;\r\n    box-shadow: 0 2px 9px rgba(30, 55, 90, 0.06);\r\n    min-width: 0;\r\n  }\r\n\r\n  .safemap-redesign .panel h3 {\r\n    font-size: 15px;\r\n    margin: 0 0 12px;\r\n    font-weight: 600;\r\n  }\r\n\r\n  /* 통계 */\r\n\r\n  .safemap-redesign .stat-grid {\r\n    display: grid;\r\n    grid-template-columns: repeat(2, minmax(0, 1fr));\r\n    gap: 10px;\r\n  }\r\n\r\n  .safemap-redesign .stat-grid.three {\r\n    grid-template-columns: repeat(3, minmax(0, 1fr));\r\n  }\r\n\r\n  .safemap-redesign .stat-box {\r\n    background: #f4f7fb;\r\n    border-radius: 8px;\r\n    padding: 10px 8px;\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    gap: 4px;\r\n  }\r\n\r\n  .safemap-redesign .stat-box span {\r\n    font-size: 13px;\r\n    color: #67758b;\r\n  }\r\n\r\n  .safemap-redesign .stat-box strong {\r\n    font-size: 25px;\r\n    font-weight: 700;\r\n  }\r\n\r\n  .safemap-redesign .stat-box small {\r\n    color: #78869a;\r\n  }\r\n\r\n  .safemap-redesign .danger {\r\n    color: #e35d64;\r\n  }\r\n\r\n  /* 시연용 안내 */\r\n\r\n  .safemap-redesign .mock-notice {\r\n    font-size: 11px;\r\n    color: #96a0ae;\r\n    text-align: left;\r\n    line-height: 1.6;\r\n    white-space: normal;\r\n    overflow-wrap: anywhere;\r\n    margin: 10px 0 4px;\r\n  }\r\n\r\n  /* 반응형 */\r\n\r\n  @media (max-width: 1000px) {\r\n    .safemap-redesign .dashboard-grid {\r\n      grid-template-columns: 1fr;\r\n    }\r\n  }\r\n\r\n  @media (max-width: 650px) {\r\n    .safemap-redesign {\r\n      padding: 14px 12px;\r\n    }\r\n\r\n    .safemap-redesign .stat-grid.three {\r\n      grid-template-columns: 1fr;\r\n    }\r\n  }\r\n\r\n  /* 위험등급별 사용자 현황 */\r\n\r\n.safemap-redesign .risk-summary {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n    padding: 3px 2px 9px;\r\n    font-size: 14px;\r\n  }\r\n\r\n  .safemap-redesign .risk-summary strong {\r\n    font-size: 21px;\r\n    color: #26354a;\r\n  }\r\n\r\n  .safemap-redesign .risk-progress {\r\n    display: flex;\r\n    height: 22px;\r\n    overflow: hidden;\r\n    border-radius: 5px;\r\n    margin-bottom: 12px;\r\n    background: #edf0f4;\r\n  }\r\n\r\n  .safemap-redesign .risk-segment {\r\n    height: 100%;\r\n  }\r\n\r\n  .safemap-redesign .risk-high {\r\n    background: #f36b70;\r\n  }\r\n\r\n  .safemap-redesign .risk-medium {\r\n    background: #ffcb26;\r\n  }\r\n\r\n  .safemap-redesign .risk-low {\r\n    background: #5b9bf1;\r\n  }\r\n\r\n  .safemap-redesign .risk-cards {\r\n    display: grid;\r\n    grid-template-columns: repeat(3, minmax(0, 1fr));\r\n    gap: 10px;\r\n  }\r\n\r\n  .safemap-redesign .risk-card {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    gap: 8px;\r\n    padding: 9px 6px;\r\n    border-radius: 7px;\r\n    background: #f4f7fb;\r\n    font-size: 13px;\r\n    white-space: nowrap;\r\n  }\r\n\r\n  .safemap-redesign .risk-card strong {\r\n    font-size: 16px;\r\n  }\r\n\r\n  .safemap-redesign .risk-dot {\r\n    width: 10px;\r\n    height: 10px;\r\n    border-radius: 50%;\r\n    flex-shrink: 0;\r\n  }\r\n\r\n  @media (max-width: 1200px) {\r\n    .safemap-redesign .risk-cards {\r\n      grid-template-columns: 1fr;\r\n    }\r\n\r\n    .safemap-redesign .risk-card {\r\n      justify-content: space-between;\r\n    }\r\n  }\r\n\r\n  /* 장비 이상 사용자 현황 */\r\n\r\n.safemap-redesign .abnormal-table-scroll {\r\n    max-height: 175px;\r\n    overflow-x: auto;\r\n    overflow-y: auto;\r\n  }\r\n\r\n  .safemap-redesign .abnormal-table {\r\n    width: 100%;\r\n    border-collapse: collapse;\r\n    font-size: 13px;\r\n  }\r\n\r\n  .safemap-redesign .abnormal-table th,\r\n  .safemap-redesign .abnormal-table td {\r\n    padding: 6px 8px;\r\n    border-bottom: 1px solid #edf0f4;\r\n    text-align: center;\r\n    vertical-align: middle;\r\n    white-space: nowrap;\r\n  }\r\n\r\n  .safemap-redesign .abnormal-table th {\r\n    position: sticky;\r\n    top: 0;\r\n    z-index: 1;\r\n    background: #f4f7fb;\r\n    color: #67758b;\r\n    font-weight: 600;\r\n  }\r\n\r\n  .safemap-redesign .abnormal-table td:nth-child(2) {\r\n    text-align: left;\r\n  }\r\n\r\n  /* 장비 상태 표시 */\r\n\r\n  .safemap-redesign .status-normal,\r\n  .safemap-redesign .status-danger,\r\n  .safemap-redesign .status-uninstalled {\r\n    display: inline-flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n\r\n    width: 62px;\r\n    height: 24px;\r\n    padding: 0 4px;\r\n\r\n    border-radius: 4px;\r\n    font-size: 12px;\r\n    font-weight: 600;\r\n    white-space: nowrap;\r\n  }\r\n\r\n  .safemap-redesign .status-normal {\r\n    color: white;\r\n    background: #21bf73;\r\n  }\r\n\r\n  .safemap-redesign .status-danger {\r\n    color: white;\r\n    background: #ef5350;\r\n  }\r\n\r\n  .safemap-redesign .status-uninstalled {\r\n    color: #666;\r\n    background: #e5e7eb;\r\n  }\r\n\r\n  /* 스크롤바 */\r\n\r\n  .safemap-redesign .abnormal-table-scroll::-webkit-scrollbar {\r\n    width: 7px;\r\n    height: 7px;\r\n  }\r\n\r\n  .safemap-redesign .abnormal-table-scroll::-webkit-scrollbar-thumb {\r\n    background: #cbd5e1;\r\n    border-radius: 10px;\r\n  }\r\n\r\n  .safemap-redesign .abnormal-table-scroll::-webkit-scrollbar-track {\r\n    background: #f4f7fb;\r\n  }\r\n\r\n  /* 읍면별 장비 현황 그래프 */\r\n\r\n.safemap-redesign .chart-panel {\r\n    margin-top: 12px;\r\n  }\r\n\r\n  .safemap-redesign .panel-heading {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    gap: 16px;\r\n  }\r\n\r\n  .safemap-redesign .panel-heading h3 {\r\n    margin: 0;\r\n  }\r\n\r\n  .safemap-redesign .panel-heading select {\r\n    padding: 9px 34px 9px 12px;\r\n    border: 1px solid #dbe2eb;\r\n    border-radius: 6px;\r\n    background: white;\r\n    cursor: pointer;\r\n  }\r\n\r\n  .safemap-redesign .chart-summary {\r\n    display: flex;\r\n    gap: 25px;\r\n    margin: 10px 0;\r\n    font-size: 14px;\r\n  }\r\n\r\n  .safemap-redesign .chart-summary strong {\r\n    margin-left: 7px;\r\n  }\r\n\r\n  .safemap-redesign .chart-container {\r\n    width: 100%;\r\n    height: clamp(160px, 20vh, 215px);\r\n    min-width: 0;\r\n  }\r\n\r\n  /* 대시보드 우측 상단 읍면별 사용자 조회 */\r\n\r\n.safemap-redesign .dashboard-top-controls {\r\n    display: flex;\r\n    justify-content: flex-end;\r\n    align-items: center;\r\n    gap: 12px;\r\n    margin-bottom: 10px;\r\n  }\r\n\r\n  .safemap-redesign .dashboard-top-controls label {\r\n    font-size: 13px;\r\n    font-weight: 600;\r\n    color: #52647a;\r\n  }\r\n\r\n  .safemap-redesign .dashboard-top-controls select {\r\n    min-width: 170px;\r\n    padding: 10px 12px;\r\n    border: 1px solid #dbe2eb;\r\n    border-radius: 7px;\r\n    background: white;\r\n    color: #26354a;\r\n    cursor: pointer;\r\n  }\r\n\r\n  @media (max-width: 650px) {\r\n    .safemap-redesign .dashboard-top-controls {\r\n      justify-content: flex-start;\r\n      flex-wrap: wrap;\r\n    }\r\n  }\r\n\r\n  /* 기기 설치 현황 - 숫자 및 상태 문구 줄바꿈 방지 */\r\n.safemap-redesign .stat-box strong {\r\n    white-space: nowrap;\r\n  }\r\n\r\n/* 대시보드 전체 높이 */\r\n.safemap-redesign {\r\n    min-height: 100vh;\r\n    display: flex;\r\n    flex-direction: column;\r\n    box-sizing: border-box;\r\n  }\r\n\r\n  /* 상단 2x2 패널은 기존 높이 유지 */\r\n  .safemap-redesign .dashboard-grid {\r\n    flex: 0 0 auto;\r\n  }\r\n\r\n  /* 하단 그래프만 남는 공간 활용 */\r\n  .safemap-redesign .chart-panel {\r\n    flex: 1 0 300px;\r\n    display: flex;\r\n    flex-direction: column;\r\n  }\r\n\r\n  /* 그래프 크기는 적당한 범위로 제한 */\r\n  .safemap-redesign .chart-container {\r\n    flex: 1;\r\n    min-height: 200px;\r\n    max-height: 340px;\r\n  }\r\n\r\n  /* 위험등급별 사용자 현황 - 세로 중앙 배치 */\r\n.safemap-redesign .risk-panel {\r\ndisplay: flex;\r\nflex-direction: column;\r\njustify-content: center;\r\nposition: relative;\r\n}\r\n\r\n/* 제목은 패널 상단에 고정 */\r\n.safemap-redesign .risk-panel > h3 {\r\nposition: absolute;\r\ntop: 16px;\r\nleft: 16px;\r\nmargin: 0;\r\n}\r\n\r\n/* 장비 이상 사용자 행 클릭 효과 */\r\n.safemap-redesign .abnormal-table tbody tr {\r\n    cursor: pointer;\r\n    transition: background-color 0.15s ease;\r\n}\r\n\r\n.safemap-redesign .abnormal-table tbody tr:hover {\r\n    background-color: #eaf3ff;\r\n}\r\n\r\n/* 신규 대시보드 - 발생현황 모달 */\r\n\r\n.safemap-redesign .modalbg {\r\n    position: fixed !important;\r\n    inset: 0;\r\n    z-index: 9998;\r\n    background: rgba(0, 0, 0, 0.4);\r\n  }\r\n\r\n  .safemap-redesign .modal.occurmodal {\r\n    display: block !important;\r\n    position: fixed !important;\r\n\r\n    top: 50%;\r\n    left: 50%;\r\n    transform: translate(-50%, -50%);\r\n\r\n    width: min(1600px, 95vw);\r\n    max-height: 90vh;\r\n    overflow-y: auto;\r\n\r\n    margin: 0;\r\n    padding: 24px;\r\n    background: #fff;\r\n    border-radius: 10px;\r\n    box-shadow: 0 10px 35px rgba(0, 0, 0, 0.2);\r\n\r\n    z-index: 9999;\r\n  }\r\n\r\n  /* 신규 대시보드 - 상황종료 모달 */\r\n\r\n.safemap-redesign .modal.processmodal {\r\n    display: block !important;\r\n    position: fixed !important;\r\n\r\n    top: 50%;\r\n    left: 50%;\r\n    transform: translate(-50%, -50%);\r\n\r\n    width: min(1200px, 92vw);\r\n    max-height: 85vh;\r\n    overflow-y: auto;\r\n\r\n    margin: 0;\r\n    padding: 24px;\r\n    background: #fff;\r\n    border-radius: 10px;\r\n    box-shadow: 0 10px 35px rgba(0, 0, 0, 0.2);\r\n\r\n    z-index: 9999;\r\n  }\r\n\r\n  /* 장비 이상 사용자 목록 - 좁은 화면 너비 대응 - 1336 */\r\n.safemap-redesign .abnormal-table {\r\n    table-layout: fixed;\r\n  }\r\n\r\n  .safemap-redesign .abnormal-table th,\r\n  .safemap-redesign .abnormal-table td {\r\n    padding: 6px 4px;\r\n  }\r\n\r\n  .safemap-redesign .abnormal-table th:nth-child(1),\r\n  .safemap-redesign .abnormal-table td:nth-child(1) {\r\n    width: 22%;\r\n  }\r\n\r\n  .safemap-redesign .abnormal-table th:nth-child(2),\r\n  .safemap-redesign .abnormal-table td:nth-child(2) {\r\n    width: 38%;\r\n    white-space: normal;\r\n    overflow-wrap: anywhere;\r\n  }\r\n\r\n  .safemap-redesign .abnormal-table th:nth-child(n+3),\r\n  .safemap-redesign .abnormal-table td:nth-child(n+3) {\r\n    width: 20%;\r\n  }\r\n\r\n  /* 장비 이상 사용자 현황 - 5열 너비 최적화 */\r\n.safemap-redesign .abnormal-table {\r\n    width: 100%;\r\n    table-layout: fixed;\r\n  }\r\n\r\n  .safemap-redesign .abnormal-table th,\r\n  .safemap-redesign .abnormal-table td {\r\n    padding: 6px 4px;\r\n  }\r\n\r\n  /* 어르신 사용자 */\r\n  .safemap-redesign .abnormal-table th:nth-child(1),\r\n  .safemap-redesign .abnormal-table td:nth-child(1) {\r\n    width: 18%;\r\n    overflow-wrap: anywhere;\r\n    white-space: normal;\r\n  }\r\n\r\n  /* 설치위치 */\r\n  .safemap-redesign .abnormal-table th:nth-child(2),\r\n  .safemap-redesign .abnormal-table td:nth-child(2) {\r\n    width: 28%;\r\n    white-space: normal;\r\n    overflow-wrap: anywhere;\r\n  }\r\n\r\n  /* 플러그, 스위치, 감지기 */\r\n  .safemap-redesign .abnormal-table th:nth-child(n+3),\r\n  .safemap-redesign .abnormal-table td:nth-child(n+3) {\r\n    width: 18%;\r\n  }\r\n\r\n  /* 좁은 화면에서 위험등급 패널 제목 겹침 방지 - 768 */\r\n@media (max-width: 1000px) {\r\n    .safemap-redesign .risk-panel {\r\n      justify-content: flex-start;\r\n    }\r\n\r\n    .safemap-redesign .risk-panel > h3 {\r\n      position: static;\r\n      margin-bottom: 16px;\r\n    }\r\n  }\r\n\r\n  /* =========================================\r\n   대시보드 글씨 크기 통일\r\n   사용자 관리 / 장비 관리와 동일한 기준\r\n========================================= */\r\n\r\n/* 패널 제목 */\r\n.safemap-redesign .panel h3 {\r\n    font-size: 18px;\r\n    line-height: 1.4;\r\n  }\r\n  \r\n  /* 통계 항목명 */\r\n  .safemap-redesign .stat-box span {\r\n    font-size: 15px;\r\n  }\r\n  \r\n  /* 주요 통계 숫자는 기존 강조 크기 유지 */\r\n  .safemap-redesign .stat-box strong {\r\n    font-size: 25px;\r\n  }\r\n  \r\n  /* 위험등급별 사용자 현황 */\r\n  .safemap-redesign .risk-summary {\r\n    font-size: 15px;\r\n  }\r\n  \r\n  .safemap-redesign .risk-card {\r\n    font-size: 15px;\r\n  }\r\n  \r\n  /* 장비 이상 사용자 목록 */\r\n  .safemap-redesign .abnormal-table {\r\n    font-size: 15px;\r\n  }\r\n  \r\n  .safemap-redesign .abnormal-table th,\r\n  .safemap-redesign .abnormal-table td {\r\n    padding: 8px 4px;\r\n    line-height: 1.4;\r\n  }\r\n  \r\n  /* 장비 상태 표시 */\r\n  .safemap-redesign .status-normal,\r\n  .safemap-redesign .status-danger,\r\n  .safemap-redesign .status-uninstalled {\r\n    font-size: 13px;\r\n    width: 68px;\r\n    height: 27px;\r\n  }\r\n  \r\n  /* 읍면별 사용자 선택 */\r\n  .safemap-redesign .dashboard-top-controls label,\r\n  .safemap-redesign .dashboard-top-controls select {\r\n    font-size: 14px;\r\n  }\r\n  \r\n  /* 그래프 상단 선택 및 요약 */\r\n  .safemap-redesign .panel-heading select {\r\n    font-size: 14px;\r\n  }\r\n  \r\n  .safemap-redesign .chart-summary {\r\n    font-size: 15px;\r\n  }\r\n  \r\n  /* 안내 문구 */\r\n  .safemap-redesign .mock-notice {\r\n    font-size: 12px;\r\n  }\r\n\r\n  /* =========================================\r\n   대시보드 세로 공간 재배분\r\n========================================= */\r\n\r\n/* 상단 통계 카드의 내부 여백 확대 */\r\n.safemap-redesign .dashboard-grid > .panel:nth-child(-n+2) {\r\n    padding-top: 24px;\r\n    padding-bottom: 24px;\r\n  }\r\n  \r\n  /* 응급상황 / 기기 설치 현황의 숫자 카드 */\r\n  .safemap-redesign .dashboard-grid > .panel:nth-child(-n+2) .stat-box {\r\n    padding-top: 18px;\r\n    padding-bottom: 18px;\r\n    gap: 8px;\r\n  }\r\n  \r\n  /* 하단 그래프 패널이 과도하게 커지지 않도록 */\r\n  .safemap-redesign .chart-panel {\r\n    flex: 0 0 auto;\r\n  }\r\n  \r\n  /* 그래프 높이 조정 */\r\n  .safemap-redesign .chart-container {\r\n    height: 250px;\r\n    min-height: 250px;\r\n    max-height: 250px;\r\n    flex: none;\r\n  }\r\n\r\n  /* 대시보드 하단 그래프 - 남는 화면 높이 활용 */\r\n\r\n.safemap-redesign .chart-container {\r\n    height: clamp(250px, calc(100vh - 670px), 480px);\r\n    min-height: 250px;\r\n    max-height: none;\r\n    flex: none;\r\n  }\n/* 발생현황 내부 사용자 상세정보 모달 */\n.safemap-redesign .modal.user-detail-modal {\n  display: block !important;\n  position: fixed !important;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  width: min(650px, 90vw);\n  max-height: 80vh;\n  overflow-y: auto;\n  margin: 0;\n  padding: 24px;\n  background: #fff;\n  border-radius: 10px;\n  box-shadow: 0 10px 35px rgba(0, 0, 0, 0.25);\n  z-index: 10001;\n}\n\n/* 발생현황 모달 테이블 가독성 개선 */\n.safemap-redesign .modal.occurmodal {\n    box-sizing: border-box;\n}\n\n.safemap-redesign .modal.occurmodal .table {\n    width: 100%;\n    overflow-x: auto;\n}\n\n.safemap-redesign .modal.occurmodal table {\n    width: 100%;\n    min-width: 1150px;\n    table-layout: auto;\n}\n\n.safemap-redesign .modal.occurmodal th,\n.safemap-redesign .modal.occurmodal td {\n    white-space: nowrap;\n    word-break: keep-all;\n    vertical-align: middle;\n    padding: 12px 10px;\n}\n\n.safemap-redesign .modal.occurmodal td button {\n    white-space: nowrap;\n    min-width: max-content;\n}\n\n/* 보호자 확인 시각 등 긴 정보는 한 줄 유지 */\n.safemap-redesign .modal.occurmodal td div {\n    white-space: nowrap;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
